module.exports = __webpack_public_path__ + "images/habr-a0d765.svg";